import React, {FC, useEffect, useMemo, useRef, useState} from 'react'
import {Link} from 'react-router-dom'
import {
  fetchData,
  getEncryptedRoute,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import Swal from 'sweetalert2'
import Select, { CSSObjectWithLabel } from 'react-select'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {ToastContainer} from 'react-toastify'
import DataTable from 'react-data-table-component'
import {left} from '@popperjs/core'
import Loader from '../components/Loader'
import moment from 'moment'
import {Tr} from '../../../_metronic/i18n/Tr'

const ViewRestaurant: FC = () => {
  let t = Tr()
   const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

  const [restaurantList, setRestauarantList] = useState([])
  const [orgRestaurantList, setOrgRestauarantList] = useState([])
  const [selectedStatus, setSelectedStatus] = useState({label: 'All', value: ''})
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const {menuId, menuIdAdd, menuIdEdit, menuIdDelete, menuIdView} = useMenuIdPermissions()

  const [statusList] = useState([
    {label: 'All', value: ''},
    {label: 'Pending', value: '0'},
    {label: 'Approved', value: '1'},
    {label: 'Rejected', value: '2'},
    {label: 'Inactive', value: '3'},
    {label: 'Active', value: '4'},
  ])

  //   hotel list api call
  const restaurantListApiCall = async (status: any = '') => {
    setIsLoading(true)

    var param: any = {}
    if (status != '' && status != null && status != undefined) {
      param['status'] = status
    }
    var res = await fetchData('vendor/public/restaurantList', param)

    if (res.status == '200') {
      setIsLoading(false)
      var data = res.data

      setRestauarantList(data)
      setOrgRestauarantList(data)
    } else {
            setIsLoading(false)

      toasterrormsg(res.message)
    }
  }

  // change restautrant status
  const changeStatus = async (restaurantId: any, status: any) => {
    var param: any = {
      categoryId: 3,
      id: restaurantId,
      adminId: adminId,

      status: status == true ? 1 : 0,
    }

    var res = await fetchData('admin/changestatus', param)
    if (res.status == '200') {
      status == '0' ? toastsuccessmsg('Unblock Successfully') : toastsuccessmsg('Block Successfully')
      restaurantListApiCall()
    } else {
      toasterrormsg(res.message)
    }
  }

  //   delete hotel api call
  const confirmdelete = (restaurantId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          restaurantId: restaurantId,
          adminId: adminId,
        }
        var res = await fetchData('vendor/public/deleteRestaurant', param)

        if (res.status == '200') {
          restaurantListApiCall(selectedStatus ? selectedStatus['value'] : '')
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }

  // contract detail api call
  const contractDetailApiCall = async (
    event: 'download' | 'view',
    vendorId: any,
    actionId: any
  ) => {
    setIsLoading(true)
    const param = {
      categoryId: '3',
      actionId: actionId,
      vendorId: vendorId,
    }

    const res = await fetchData('admin/generatePdfContract', param)

    if (res.status == '200') {
      setIsLoading(false)
      const data = res.data

      if (data.url) {
        if (event == 'download') {
          const link = document.createElement('a')
          link.href = data.url
          link.download = ''
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else if (event == 'view') {
          window.open(data.url, '_blank')
        }
      } else {
        setIsLoading(false)

        toasterrormsg('Document URL not found.')
      }
    } else {
      setIsLoading(false)

      toasterrormsg(res.message)
    }
  }

  // search hotel
  const restaurantSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setRestauarantList(orgRestaurantList)
    } else {
      var tmp: any = orgRestaurantList.filter((item: any) => {
        return (
          (item.en_name != null &&
            item.en_name != '' &&
            String(item.en_name).toLowerCase().includes(text.toLowerCase())) ||
          (item.vendorDetails[0].fullName != null &&
            item.vendorDetails[0].fullName != '' &&
            String(item.vendorDetails[0].fullName).toLowerCase().includes(text.toLowerCase())) ||
          (item.type != null &&
            item.type != '' &&
            String(item.type).toLowerCase().includes(text.toLowerCase())) ||
          (item.submitDate != null &&
            item.submitDate != '' &&
            String(item.submitDate).toLowerCase().includes(text.toLowerCase())) ||
          (item.verifiedDate != null &&
            item.verifiedDate != '' &&
            String(item.verifiedDate).toLowerCase().includes(text.toLowerCase()))
        )
      })
      setRestauarantList(tmp)
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      sessionStorage.removeItem('vendor')
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Property Name')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end ' data-kt-user-table-toolbar='base'>
          <Select
            className='me-3'
            options={statusList}
            value={selectedStatus}
            placeholder={t('Select Status')}
            onChange={(e: any) => {
              setSelectedStatus(e)
              restaurantListApiCall(e.value)
              sessionStorage.setItem('selectedStatus', e.value)
            }}
            styles={{container: (provided : CSSObjectWithLabel) => ({...provided, width: 150, textAlign: left})}}
          />
          {menuIdAdd ? (
            <Link
              className='btn btn-success monthBtn text-white h-40px'
              id='kt_toolbar_primary_button'
              style={{color: 'rgb(24, 28, 50)'}}
              to={getEncryptedRoute('../addrestaurantbasicinfo/', {menuId:menuId})}
            >
              + {t('Add Cafe & Restaurant')}
            </Link>
          ) : (
            ''
          )}
        </div>
      </div>
    )
  }

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('Property Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-6 d-flex align-items-center justify-content-center'>
              <img
                className='w-50px h-50px me-2'
                src={
                  row.images.length > 0
                    ? row.images[0]['thumbPath']
                    : toAbsoluteUrl('/media/logos/uztripLogo.png')
                }
                alt='images'
              />
              <Link
                to={getEncryptedRoute('../restaurantoverview/', {menuId:menuId})}
                state={{restaurantId: row.restaurantId}}
                className='text-dark fw-bold text-hover-primary fs-5'
              >
                <label className='cursor-pointer'>{row.en_name}</label>
              </Link>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: t('Vendor Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.vendorDetails && row.vendorDetails.length > 0
                ? row.vendorDetails[0].fullName
                : ''}
            </div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) =>
          row.vendorDetails && row.vendorDetails.length > 0 ? row.vendorDetails[0].fullName : '',
      },
      {
        name: t('Property Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.type || ''}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.type),
        filter: true,
      },

      {
        name: t('Submitted Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.submitDate || '--'}</div>
          </div>
        ),

        sortable: true,
        selector: (row: any) => String(row.submitDate),
        sortFunction: (rowA: any, rowB: any) => {
          const date1 = rowA.submitDate
            ? moment(rowA.submitDate, ['DD-MM-YYYY']).format('YYYY-MM-DD')
            : null
          const date2 = rowB.submitDate
            ? moment(rowB.submitDate, ['DD-MM-YYYY']).format('YYYY-MM-DD')
            : null

          const dateA = date1 ? new Date(date1) : null
          const dateB = date2 ? new Date(date2) : null

          // Handle the case where one or both dates are empty
          if (!dateA && !dateB) return 0 // Both dates are empty
          if (!dateA) return 1 // Empty dates go to the end (you can change this to -1 if you want empty first)
          if (!dateB) return -1

          // Sorting logic: Ascending or Descending based on the click
          if (dateA < dateB) return -1 // Ascending
          if (dateA > dateB) return 1 // Descending
          return 0
        },
        filter: true,
      },
      {
        name: t('Verified Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.verifiedDate || '--'}</div>
          </div>
        ),

        sortable: true,
        selector: (row: any) => String(row.verifiedDate),
        sortFunction: (rowA: any, rowB: any) => {
          const date1 = rowA.verifiedDate
            ? moment(rowA.verifiedDate, ['DD-MM-YYYY']).format('YYYY-MM-DD')
            : null
          const date2 = rowB.verifiedDate
            ? moment(rowB.verifiedDate, ['DD-MM-YYYY']).format('YYYY-MM-DD')
            : null

          const dateA = date1 ? new Date(date1) : null
          const dateB = date2 ? new Date(date2) : null

          // Handle the case where one or both dates are empty
          if (!dateA && !dateB) return 0 // Both dates are empty
          if (!dateA) return 1 // Empty dates go to the end (you can change this to -1 if you want empty first)
          if (!dateB) return -1

          // Sorting logic: Ascending or Descending based on the click
          if (dateA < dateB) return -1 // Ascending
          if (dateA > dateB) return 1 // Descending
          return 0
        },
        filter: true,
      },
      {
        name: t('Verification Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
              {row.businessInfostatus == 0 ? (
                <span className='badge badge-warning mx-2'>{t('Pending')}</span>
              ) : row.businessInfostatus == 1 ? (
                <span className='badge badge-success mx-2'>{t('Verified')}</span>
              ) : (
                <span className='badge badge-danger mx-2'>{t('Rejected')}</span>
              )}
            </label>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.businessInfostatus),
        filter: true,
      },
      {
        name: t('Contract Agreement'),
        cell: (row: any) => (
          <div className='my-3 gap-2 d-flex '>
            <button
              className='btn btn-sm p-2 btn-success'
              onClick={() => {
                contractDetailApiCall('download', row.vendorId, row.restaurantId)
              }}
            >
              {' '}
              {t("Download")}
            </button>
            <button
              className='btn btn-primary btn-sm p-2'
              onClick={() => {
                contractDetailApiCall('view', row.vendorId, row.restaurantId)
              }}
            >
              {' '}
                            {t("View")}

            </button>
          </div>
        ),
        sortable: false,
        selector: (row: any) => String(row.businessInfostatus),
        filter: false,
        width: '200px',
      },
      {
        name: t('Status'),
        cell: (row: any) => (
          <div className='my-3'>
            {menuIdEdit ? (
              <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
                <input
                  className='form-check-input cursor-pointer'
                  type='checkbox'
                  value='1'
                  title={row.block == 0 ? 'Active' : 'Inactive'}
                  checked={row.block == 0 ? true : false}
                  onChange={() => changeStatus(row.restaurantId, !row.block)}
                />
              </label>
            ) : (
              ''
            )}
          </div>
        ),
        sortable: false,
        filter: false,
        width: '100px',
      },

      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {menuIdEdit ? (
              <Link
                to={getEncryptedRoute('../addrestaurantbasicinfo/', {menuId:menuId})}
                state={{restaurantId: row.restaurantId, vendorId: row.vendorId}}
                className='btn btn-sm btn-icon btn-color-success btn-active-light-success'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
              >
                <KTIcon iconName='notepad-edit' className='fs-2' />
              </Link>
            ) : (
              ''
            )}

            {menuIdDelete ? (
              <button
                onClick={() => confirmdelete(row.restaurantId)}
                className='btn btn-sm btn-icon btn-color-success btn-active-light-success'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
              >
                <KTIcon iconName='trash-square' className='fs-2' />
              </button>
            ) : (
              ''
            )}
          </>
        ),
        width: '140px',
      },
    ],
    [t]
  )
  useEffect(() => {
    setSelectedStatus({label: 'All', value: ''})

    restaurantListApiCall('')
    document.title = 'Insayr | View Restaurants'
  }, [])

  return (
    <>
      {isLoading && <Loader />}

      <ToastContainer />

      <>
        <DataTable
          columns={column}
          data={restaurantList}
          pagination
          paginationServer={false}
          subHeader={true}
          subHeaderComponent={
            <CustomHeader search={searchTerm} isfoc={focus} customSearch={restaurantSearch} />
          }
          paginationComponentOptions={{
            rowsPerPageText: t('Rows Per Page'),
          }}
        />
      </>
    </>
  )
}

export {ViewRestaurant}
